import {useHistory, useParams} from "react-router-dom";
import {DashboardLayout} from "components/Layout";
import {SubmitButton} from "components/Button";
import {CircleLoader} from "components/Loader";
import {FormCard} from "components/Form";
import {useDetailUnit} from "hooks/SuperAdmin/Unit";

export function MasterUnitDetailPage() {
	const history = useHistory();
	const {id} = useParams();
	const {data: detailUnit, isLoading: loadingFetcing} = useDetailUnit(id);

	if (loadingFetcing) {
		return (
			<DashboardLayout>
				<FormCard backTitle="Daftar list unit" title="Detail Unit">
					<CircleLoader />
				</FormCard>
			</DashboardLayout>
		);
	}

	return (
		<DashboardLayout>
			<FormCard
				backTitle="Daftar List Unit"
				title={`Detail Data Unit ${detailUnit?.data?.name}`}
				onBackButtonClick={() => history.push("/master-unit")}>
				<div class="row gx-2 mb-5">
					<div class="col-sm-6 col-6">
						<div class="setting-item">
							<label class="setting-label ">Nama Unit</label>
							<p className="text-bold text-grey">{detailUnit?.data?.name}</p>
						</div>
					</div>
				</div>

				<div class="text-center my-3">
					<SubmitButton
						className="btn btn-orange d-inline-block mw-250"
						text="Ubah Data Ini"
						onClick={() => history.push(`/master-unit/edit/${detailUnit?.data?.id}`)}
					/>
				</div>
			</FormCard>
		</DashboardLayout>
	);
}
